<template>
    <div>
    
        <s-button @onclick="refresh" label="refresh"/>
        <table border="1">
            <tr>
                <th>Date</th>
                <th>Concours en club</th>
                <th>Concours en mode test</th>
            </tr>
            <tr v-for="stat in stats">
                <td> {{stat.id}} </td>
                <td> {{stat.nb}} </td>
                <td> {{stat.demo}} </td>
            </tr>
         </table>
    </div>
</template>
<style scoped>
   th {
       text-align: 'center';
       padding: 3px;
       
   }
   td {
       text-align: 'center';
       padding: 3px;
       
   }
</style>
<script>
import firebase_api from '@/firebase/firebase_api'

export default {
    data() {
        return {
            stats: []
            
        };
    },
    methods: {
        refresh() {
            this.stats = [];
            firebase_api.api.getDb().collection("stat").get().then(docs=>{
                        docs.forEach(doc=>{
                            var tempo = doc.data();
                            tempo.id = doc.id;
                            this.stats.push(tempo)
                        })
                    })
        }
    },
    mounted() {
       
    }
}
</script>